import { useHistory, useLocation } from 'react-router-dom';

import useMount from 'hooks/useMount';
import { routeColors, defaultColor } from 'constants/routeColors';

const root = document.documentElement;

function useCssVariables() {
  const history = useHistory();
  const location = useLocation();

  const setCssVariable = ({ pathname }) => {
    const color = routeColors.find(({ route }) => pathname.startsWith(route))?.color;

    root.style.setProperty('--color-primary', color || defaultColor);
  };

  useMount(() => {
    setCssVariable(location);

    return history.listen(setCssVariable);
  });

  return null;
}

export default useCssVariables;
